// extracted by mini-css-extract-plugin
module.exports = {"EventsSecretScreen":"eventsSecretScreen_EventsSecretScreen__3rNyK","CardsTable":"eventsSecretScreen_CardsTable__pGMgM"};